import FormInputAffix from "../../../../../../packages/design-system/src/FormInputAffix";
import FormInput from "../../../../../../packages/design-system/src/FormInput";
import FormInputGroup from "../../../../../../packages/design-system/src/FormInputGroup";
import * as React from 'react';
export default {
  FormInputAffix,
  FormInput,
  FormInputGroup,
  React
};